import { api } from "@/api";

import { Sport } from "@/types/ApiResponses/Sport";
import { QueryProps } from "@/types/Api";

interface Props {
  name?: string;
  lang?: string;
  popular?: boolean;
}

export const getFavoriteSports = async (
  props: QueryProps<Props>
): Promise<Sport[]> => {
  const res = await api.client.get(`/sports-new/favorite`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
